import React from 'react';

const Vue_Props = () => {
  return (
    <div>
      <h1>Vue_Props Component</h1>
      <p>This is the Vue_Props tutorial page.</p>
    </div>
  );
}

export default Vue_Props;
